import { z } from "zod";
import { updatedResponseSchema } from "./common.js";
export const refiningRoundStatusSchema = z.enum(["OPEN", "DELIVERED", "SETTLED"]);
const receiptGrams = z.number().nonnegative().max(1_000_000);
const receiptNok = z.number().nonnegative().max(100_000_000);
/** The day on KA's paper, as epoch ms; the modal sends noon Oslo time of the picked day. */
const receiptDate = z.number().int().positive();
const kaReference = z.string().trim().max(120);
export const addToRefiningRoundSchema = z.object({
    deliveryIds: z.array(z.string().min(1)).min(1).max(500),
});
export const addToRefiningRoundResponseSchema = z.object({
    roundId: z.string(),
    year: z.number().int(),
    number: z.number().int(),
    added: z.number().int(),
});
export const deliverRefiningRoundSchema = z.object({
    deliveredAt: receiptDate,
    deliveredNetGrams: receiptGrams,
    deliveredGrossGrams: receiptGrams,
    deliveredKaReference: kaReference.optional(),
});
export const settleRefiningRoundSchema = z.object({
    settledAt: receiptDate,
    settlementNok: receiptNok,
    settlementKaReference: kaReference.optional(),
    refiningCostNok: receiptNok.nullable().optional(),
});
export const refiningRoundActionSchema = z.discriminatedUnion("action", [
    z.object({ action: z.literal("deliver"), payload: deliverRefiningRoundSchema }),
    z.object({ action: z.literal("settle"), payload: settleRefiningRoundSchema }),
]);
export const refiningRoundActionResponseSchema = z.object({ status: refiningRoundStatusSchema });
/** The receipt fields a round has once it is delivered, and once it is settled. */
export const REFINING_DELIVERED_FIELDS = [
    "deliveredAt",
    "deliveredNetGrams",
    "deliveredGrossGrams",
    "deliveredKaReference",
];
export const REFINING_SETTLED_FIELDS = [
    "settledAt",
    "settlementNok",
    "settlementKaReference",
    "refiningCostNok",
];
/** A correction to figures already typed, or the refining invoice arriving late. Null clears an optional field. */
export const updateRefiningRoundSchema = z
    .object({
    deliveredAt: receiptDate,
    deliveredNetGrams: receiptGrams,
    deliveredGrossGrams: receiptGrams,
    deliveredKaReference: kaReference.nullable(),
    settledAt: receiptDate,
    settlementNok: receiptNok,
    settlementKaReference: kaReference.nullable(),
    refiningCostNok: receiptNok.nullable(),
})
    .partial()
    .refine((fields) => Object.keys(fields).length > 0, { message: "Ingen felt å oppdatere" });
export const updateRefiningRoundResponseSchema = updatedResponseSchema;
export const removeFromRefiningRoundResponseSchema = z.object({ removed: z.literal(true) });
